module.exports = __webpack_public_path__ + "static/media/ready.c055698f.mp3";